import Tool from '../tool';
import * as constants from '../../constants';
import stage from '../../stage';
import { sprite as exitModal } from '../../screens/test/exit-modal';

const input = document.getElementById('text-input-tool-input');

let currentQuestion;

const sprite = new PIXI.Sprite();

const titleText = new PIXI.Text('', { font: '18px Open Sans, Arial', fill: 0xFFFFFF });
titleText.anchor.set(0.5, 0);
titleText.x = constants.screenCentreX;

const eqtn = new PIXI.Sprite();
eqtn.anchor.set(0.5, 0);

const solution = new PIXI.Text('', { font: '24px Open Sans, Arial', fill: constants.green });
solution.anchor.set(0.5, 0);
solution.x = constants.screenCentreX;

sprite.addChild(titleText);
sprite.addChild(eqtn);
sprite.addChild(solution);

titleText.y = 130;
eqtn.y = titleText.y + 85;
solution.y = eqtn.y + 100;

const eqtnFontSize = 48;
const eqtnStyle = { font: `${ eqtnFontSize }px Open Sans, Arial`, fill: 0xFFFFFF };

const missingTerm = new PIXI.Container();
eqtn.addChild(missingTerm);

const missingTermBg = new PIXI.Graphics();
const missingTermWidth = 120;
missingTerm.addChild(missingTermBg);

const missingTermText = new PIXI.Text('', eqtnStyle);
missingTerm.addChild(missingTermText);
missingTermText.anchor.set(0.5, 0);
missingTermText.x = missingTermWidth / 2;

redrawMissingTerm(0xFFFFFF);

input.onkeydown = e => {
  const key = ( e.key || String.fromCharCode(e.keyCode) ).toLowerCase();

  const chars = input.value.length;
  const numericChars = input.value[ 0 ] === '-' ? chars - 1 : chars;

  const isValid =
    e.altKey || e.ctrlKey || e.metaKey ||
    key === 'backspace' || e.keyCode === 8 ||
    ( !chars && key === '-' ) ||
    ( numericChars < 3 && ~'0123456789'.indexOf(key) );

  if ( !isValid ) {
    e.preventDefault();
    e.stopImmediatePropagation();
    return false;
  }
};

input.onkeyup = e => {
  const sign = input.value[ 0 ] === '-' ? '-' : '';
  const abs = input.value.slice(sign.length);
  input.value = sign + ( abs === '' || isNaN(abs) ? '' : Math.floor(abs) );

  updateAnswer();
};

input.onchange = updateAnswer;

function updateAnswer() {
  const val = input.value.trim();
  currentQuestion.answer = !val.length || isNaN(val) ? null : Number(val);
}

const multiplicandText = new PIXI.Text('', eqtnStyle);
const multText = new PIXI.Text(constants.multiplicationSign, eqtnStyle);
const multiplierText = new PIXI.Text('', eqtnStyle);
const equalsText = new PIXI.Text('=', eqtnStyle);
const productText = new PIXI.Text('', eqtnStyle);
const terms = [ multiplicandText, multText, multiplierText, equalsText, productText ];
const operands = [ multiplicandText, multiplierText, productText ];

terms.forEach(( t, i ) => {
  eqtn.addChild(t);
  t.anchor.set(0);
});

export default class TextInputTool extends Tool {
  static init() {
    this._sprite = sprite;
    stage.on('stage-rescale', scaleAndPositionTextInput);
  }

  static loadQuestion( question ) {
    super.loadQuestion(question);
    currentQuestion = question;
    titleText.text = question.title;

    multiplicandText.text = question.multiplicand;
    multiplierText.text = question.multiplier;
    productText.text = question.product;

    operands.forEach(( t, i ) => t.visible = i !== question.missingTermIndex);

    redrawMissingTerm(0xFFFFFF);
    missingTerm.visible = false;
    solution.visible = false;

    const padding = 15;
    let x = 0;
    terms.forEach(( t, i ) => {
      if ( i ) {
        x += padding;
      }
      t.x = x;

      const operandIx = operands.indexOf(t);
      if ( operandIx === question.missingTermIndex ) {
        missingTerm.x = t.x;
        x += missingTerm.width;
      } else {
        x += t.width;
      }
    });
    eqtn.x = ( constants.screenWidth - x ) / 2;

    input.style.display = 'block';
    input.value = '';
    scaleAndPositionTextInput();
  }

  static onQuestionComplete( question ) {
    super.onQuestionComplete(question);

    input.style.display = 'none';

    missingTerm.visible = true;
    missingTermText.text = question.answer === null ? '' : question.answer;
    redrawMissingTerm(question.result ? constants.green : constants.red );

    if ( !question.result ) {
      solution.text = `Solution: ${ question.multiplicand } ${ constants.multiplicationSign } ${ question.multiplier } = ${ question.product }`;
      solution.visible = true;
    }
  }
}

function scaleAndPositionTextInput() {
  missingTerm._recursivePostUpdateTransform(); // required to populate missingTerm.worldTransform
  const canvas = document.getElementsByTagName('canvas')[ 0 ];
  const canvasOffset = canvas.getBoundingClientRect();

  const scale = missingTerm.worldTransform.a * PIXI.settings.RESOLUTION;

  input.style.transform = `scale(${ scale }, ${ scale })`;
  input.style.left = `${ canvasOffset.left + missingTerm.worldTransform.tx * PIXI.settings.RESOLUTION }px`;
  input.style.top = `${ canvasOffset.top  + missingTerm.worldTransform.ty * PIXI.settings.RESOLUTION }px`;
}

function redrawMissingTerm( bgColour ) {
  missingTermBg.clear().beginFill(bgColour).drawRect(0, 0, missingTermWidth, 55).endFill();
}

exitModal.on('show-hide', () => {
  if ( currentQuestion && !currentQuestion.isCompleted ) {
    input.style.display = exitModal.visible ? 'none' : 'block';
  }
});
